export default __webpack_public_path__ + "static/media/koodo.9a0609e0.png";